const useCustomFilterOption = () => {
  // Allows filtering options based on label and subtitle
  const filterOption = (option, inputValue) => {
    const searchValue = inputValue.toLowerCase()
    const {label, data} = option
    const subtitle = data?.subtitle
    return (
      label.toLowerCase().includes(searchValue)
      || (subtitle?.toLowerCase().includes(searchValue))
    )
  }

  return {filterOption}
}

export default useCustomFilterOption
